import axios from 'axios';
import { BASE_URL } from '../constants/api-urls';

export interface CreateShareLinkPayload {
  uri: string;
  playlistId: string;
  id: string;
  ref: string;
  position: number | string;
  originalDate: Date;
  endTime: string;
}

export const createShareLinkToken = async (payload: CreateShareLinkPayload): Promise<string> => {
  const response = await axios(`${BASE_URL}/createShareLinkToken/`, {
    data: payload,
    method: 'post',
  });
  return response.data.data.token;
};

export const buildShareUrl = (token: string): string =>
  `${window?.location?.origin}/track-detail?token=${token}`;
